











import { openSelectList } from '@/main/router/routerPath';
import { NdCenik } from '@/modules/sklad/ndCenik/';

import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME, SelectType } from '../constants';
import { apiProvider } from '../api';

type Data = {
	ZAZNAM_ID: number;
	TEXT: string;
	X_CENA_S_DPH: number;
	VYDEJ_MJ_ID: number;
	VYROBEKND_OZN: string;
	STAV: number;
	X_ND_NR: string;
	X_TEXT: string;
};

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'ND_NR' },
		showLabel: { type: Boolean, default: true },
		ndnr: { validator: (prop) => typeof prop === 'string' || prop === null, required: true },
		inputDisabled: { type: Boolean, default: undefined },
		selectType: { default: SelectType.Both, validator: (v) => SelectType[v] !== undefined },
	},
	data() {
		return {
			storeObject: NAME,
			apiProvider,
			emptyObject: {
				value: null,
				text: null,
				ndnr: null,
				cenasdph: null,
				vydejmjid: null,
				vyrobekndozn: null,
				STAV: null,
				X_ND_NR: null,
			},
		};
	},
	computed: {
		ndNrCmp: {
			get() {
				return this.ndnr;
			},
			set(val) {
				this.$emit('update:ndnr', val);
			},
		},
		inputDisabledCmp() {
			return this.isDisabled || this.inputDisabled;
		},
		PartSearchFilter(): object {
			return { TEXT: this.filter.TEXT };
		},
	},
	methods: {
		focusInput() {
			(this.$refs.input as HTMLFormElement).focus();
		},
		dbToBaseMapper(data: Data) {
			return {
				value: data.ZAZNAM_ID,
				text: data.TEXT,
				ndnr: data.X_ND_NR,
				cenasdph: data.X_CENA_S_DPH,
				vydejmjid: data.VYDEJ_MJ_ID,
				vyrobekndozn: data.VYROBEKND_OZN,
				STAV: data.STAV,
			};
		},
		async openGrid() {
			const name = this.selectType === SelectType.NdCenik ? NdCenik.name : this.storeObject;

			await openSelectList(name, {
				afterRowSelection: this.selected,
				filter: { ...this.filter, selectType: this.selectType },
			});
			this.setPageManagerMapper();
		},
	},
});
